import * as Sentry from '@sentry/browser';
import throttle from 'lodash/throttle';

async function trackUploadEvent(shortcode, payload) {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_NEW_API_HOST}/uploads/${shortcode}/track`,
      {
        credentials: 'include',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Pragma: 'no-cache',
          'Cache-Control': 'no-cache',
        },
        body: JSON.stringify(payload),
      }
    );
    if (!response.ok) {
      const error = await response.json();
      throw Error(error.message);
    }
  } catch (error) {
    Sentry.captureException(error);
  }
}

async function trackUploadProgressInternal(shortcode, uploadPercent) {
  return trackUploadEvent(shortcode, { uploadPercent, event: 'progress' });
}

export const trackUploadProgress = throttle(
  trackUploadProgressInternal,
  10000,
  {
    leading: false,
  }
);

export const trackUploadCompleted = (shortcode) =>
  trackUploadEvent(shortcode, { event: 'complete' });
